import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/refresh.svg'
import _imports_1 from '@/app/ui/assets/svg/bg-sti-summary-stt.svg'
import _imports_2 from '@/app/ui/assets/svg/chevron-right-white.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-085f5d7c")

_pushScopeId("data-v-085f5d7c")
const _hoisted_1 = {
  id: "STI",
  class: "pt-8 bg-white flex flex-col  text-12px xxl:text-14px overflow-hidden h-screen relative w-full"
}
const _hoisted_2 = { class: "flex flex-col justify-between items-start border-b border-gray-lp-400 z-20 relative pt-8" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "w-full border-t border-gray-lp-400 mt-3" }, null, -1)
const _hoisted_4 = { class: "flex flex-row py-4 align-middle items-center justify-between w-full" }
const _hoisted_5 = { class: "font-semibold text-20px mr-4 text-black-lp-200 title-layout flex flex-row align-middle justify-center" }
const _hoisted_6 = {
  class: "mr-8",
  style: {"align-self":"center"}
}
const _hoisted_7 = { class: "overflow-auto h-screen mb-3" }
const _hoisted_8 = { class: "flex flex-col w-full mt-4 pb-1" }
const _hoisted_9 = { class: "flex justify-end items-center " }
const _hoisted_10 = { class: "text-14px font-montserrat font-normal text-gray-500" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "ml-2",
  src: _imports_0
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "absolute top-0 right-0 bottom-0 object-cover h-full",
  src: _imports_1
}, null, -1)
const _hoisted_13 = { class: "flex flex-col w-1/2" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "font-montserrat font-bold line-height-075 text-20px" }
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  class: "ml-2",
  src: _imports_2
}, null, -1)
const _hoisted_17 = { class: "flex flex-row mt-3" }
const _hoisted_18 = { class: "font-montserrat font-bold line-height-075 text-60px" }
const _hoisted_19 = { class: "font-montserrat font-bold line-height-075 text-34px mt-5 ml-4" }
const _hoisted_20 = { class: "flex flex-col w-1/4 mt-6" }
const _hoisted_21 = { class: "font-montserrat font-bold line-height-075 text-20px" }
const _hoisted_22 = { class: "flex flex-col w-1/4 mt-6" }
const _hoisted_23 = { class: "font-montserrat font-bold line-height-075 text-20px" }
const _hoisted_24 = { class: "flex flex-row mt-4 mb-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_Search = _resolveComponent("Search")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_TableV2 = _resolveComponent("TableV2")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Breadcrumb),
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("sti.pageTitle")), 1)
        ]),
        (_ctx.ableToCreate)
          ? (_openBlock(), _createBlock(_component_lp_button, {
              key: 0,
              onClick: _ctx.goToUpdate,
              title: _ctx.$t('sti.updateButton'),
              textColor: "white"
            }, null, 8, ["onClick", "title"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("sti.dataUpdatedEvery10Min")), 1),
          _hoisted_11,
          _createVNode("div", {
            class: "text-14px font-montserrat font-normal text-red-500 ml-1 cursor-pointer underline",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onRefreshSTISummary && _ctx.onRefreshSTISummary(...args)))
          }, _toDisplayString(_ctx.$t("sti.refresh")), 1)
        ]),
        _createVNode("div", {
          class: "background-gradient-red text-white px-6 pt-4 pb-6 rounded-lg shadow-lg w-full flex justify-between items-center cursor-pointer relative",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.gotoNeedToStiPage && _ctx.gotoNeedToStiPage(...args)))
        }, [
          _hoisted_12,
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("sti.totalUnprocessedSti")), 1),
              _hoisted_16
            ]),
            _withDirectives(_createVNode(_component_skeleton, {
              class: "mt-3",
              width: "340px",
              height: "62px"
            }, null, 512), [
              [_vShow, _ctx.isLoadingSTTSummary]
            ]),
            _withDirectives(_createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, _toDisplayString(_ctx.formatSTTNumber(_ctx.STISTTDueSummaryData.totalBooked)), 1),
              _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("sti.partner")), 1)
            ], 512), [
              [_vShow, !_ctx.isLoadingSTTSummary]
            ])
          ]),
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("sti.stiCurrent")), 1),
            _withDirectives(_createVNode(_component_skeleton, {
              class: "mt-2",
              width: "156px",
              height: "41px"
            }, null, 512), [
              [_vShow, _ctx.isLoadingSTTSummary]
            ]),
            _withDirectives(_createVNode("div", { class: "font-montserrat font-bold line-height-075 text-34px mt-2" }, _toDisplayString(_ctx.formatSTTNumber(_ctx.STISTTDueSummaryData.totalNow)) + " " + _toDisplayString(_ctx.$t("sti.unitStt")), 513), [
              [_vShow, !_ctx.isLoadingSTTSummary]
            ])
          ]),
          _createVNode("div", _hoisted_22, [
            _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("sti.stiOverdue")), 1),
            _withDirectives(_createVNode(_component_skeleton, {
              class: "mt-2",
              width: "156px",
              height: "41px"
            }, null, 512), [
              [_vShow, _ctx.isLoadingSTTSummary]
            ]),
            _withDirectives(_createVNode("div", { class: "font-montserrat font-bold line-height-075 text-34px mt-2" }, _toDisplayString(_ctx.formatSTTNumber(_ctx.STISTTDueSummaryData.totalOverdue)) + " " + _toDisplayString(_ctx.$t("sti.unitStt")), 513), [
              [_vShow, !_ctx.isLoadingSTTSummary]
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_24, [
        _createVNode(_component_Search, {
          class: "w-64 self-center",
          onInput: _ctx.onSearch,
          onClear: _ctx.clearSearch,
          value: _ctx.searchValue,
          placeholder: _ctx.$t('sti.searchPlaceholderReverseScan'),
          minChar: 1,
          timeout: 1000
        }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
        _createVNode(_component_time_range_picker, {
          startDate: _ctx.periodeStart,
          endDate: _ctx.periodeEnd,
          onSelect: _ctx.setPeriode,
          default: _ctx.$t('7 hari terakhir')
        }, null, 8, ["startDate", "endDate", "onSelect", "default"])
      ]),
      _createVNode(_component_TableV2, {
        columns: _ctx.columns,
        data: _ctx.STIList,
        loading: _ctx.isLoading,
        pagination: _ctx.pagination,
        "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => (_ctx.pagination = $event)),
        onRequest: _ctx.fetchSTIList,
        onClick: _ctx.goToDetail,
        isDetailAble: _ctx.ableToDetail,
        errorCause: _ctx.errorCause,
        onTryAgain: _ctx.fetchSTIList
      }, null, 8, ["columns", "data", "loading", "pagination", "onRequest", "onClick", "isDetailAble", "errorCause", "onTryAgain"])
    ])
  ]))
})